import { useEffect, useRef } from "react";

// Silently re-runs `callback` every `intervalMs` while `active` is true and the tab is
// visible. Also refetches INSTANTLY the moment the tab regains focus (visibilitychange /
// window focus), so a user returning to the tab never sees stale data or has to reload.
export function usePolling(callback, intervalMs = 8000, active = true) {
  const savedRef = useRef(callback);
  useEffect(() => { savedRef.current = callback; }, [callback]);
  useEffect(() => {
    if (!active) return undefined;
    const id = setInterval(() => {
      if (document.visibilityState === "visible") savedRef.current();
    }, intervalMs);
    const onVisible = () => {
      if (document.visibilityState === "visible") savedRef.current();
    };
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", onVisible);
    return () => {
      clearInterval(id);
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("focus", onVisible);
    };
  }, [intervalMs, active]);
}
